export default __webpack_public_path__ + "static/media/hero.7c4b5c77.png";